// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__zghXG","heading":"Categories_heading__J0GBs"};